import React from 'react';
import PropTypes from 'prop-types';
// Only global rules are left in this file (theme variables and app-wide
// react-select overrides); importing it keeps their place in the cascade
import './EditProjectModal.module.css';
import ProjectFormModal from './projectForm/ProjectFormModal';

/** "Proje Düzenle" (Tailwind form shared with "Yeni Proje Ekle"). */
const EditProjectModal = ({ project, onClose, onUpdate }) => <ProjectFormModal project={project} onClose={onClose} onSaved={onUpdate} />;

EditProjectModal.propTypes = {
  project: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

export default EditProjectModal;
